module.exports = __webpack_public_path__ + "assets/36376d6aa5ac3c2d5cec4462dfb015ac.mp3";